export class ModeEnumConverter {
    static convertNumberToEnum = (value: number, enumObject: any) => {
        const modeType = enumObject[value];
        return enumObject[modeType]
    }
}